import React, { Component } from "react"
import { connect } from "react-redux"
import {Dialog, Icon} from "react-weui"
import { X } from "react-feather"
import {keys} from "lodash"
import { push } from "connected-react-router"
import Ionicon from "react-ionicons"

import { publicTagNames } from "../../../../data"
import { getSelections } from "../selectors"

import './ModalTagSelector.less'

const typesColor = {
  "2sn6dbecc3": "#D02800", // RESTAURANT
  "80ulgbfn21": "#00963D", // ENTRADAS
  k0bb01mkds: "#FF8802", // ONEDAY
  chzlh8hklq: "#0979AA", // COMPRAS
}

class UnconnectedModalTagSelector extends Component {
  constructor(props) {
    super(props)
    this.state = {
    }
  }

  componentGrid(key, label) {
    return {
      label,
      background : (key == "restaurants"
        ? "/static/img/gridImages/gastro.jpeg"
        : `/static/img/gridImages/${key}background.jpg`
      ),
      onClick: () => this.props.onType(key)
    }
  }

  gridComponents() {
    return [
      this.componentGrid("", "Todos"),
      this.componentGrid("restaurants", "美食"),
      this.componentGrid("tickets", "门票"),
      this.componentGrid("onedaytrips", "周边一日游"),
      this.componentGrid("compras", "购物"),
    ]
  }

  render() {
    return (
      <Dialog
        type="ios"
        show
        style={{
          maxHeight: "90%",
          height: "90%",
          maxWidth: window.matchMedia("(min-width: 735px)").matches ? "360px" : "85%",
          width: window.matchMedia("(min-width: 735px)").matches ? "360px" : "85%",
          padding: "1vh"
        }}
      >
        <div style={{display: "flex", flexDirection: "column", height: "100%", maxHeight: "100%"}}>

          <div style={{display: "flex", flexBasis: "10vh", lineHeight: "10vh", backgroundColor: "white", fontSize: "240%", flexShrink: 0}}>
            <div style={{flexGrow: 1}}>
              类型
            </div>
            <X
              style={{marginTop: "1vh"}}
              size="8vh"
              onClick={() => this.props.onClose(false)}
            />
          </div>

          <div style={{display: "flex", flexGrow: 2, flexShrink: 2, overflow: "auto", flexDirection: "column", backgroundColor: "#F8F8F8"}}>
            {
              [
                <div
                  key="asda"
                  style={{
                    position: "relative",
                    border: `1px solid ${!this.props.selectedTag ? "rgb(26, 173, 25)" : "#ccc"}`,
                    margin: "0.5vh 0 0.5vh 0",
                    backgroundColor: "white",
                    minHeight: "6vh",
                    textAlign: "center",
                    fontSize: "150%",
                    flexGrow: 1,
                    flexShrink: 0,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                  onClick={() => this.props.onTag("")}
                >
                  看全部
                  <div style={{position: "absolute", right: "5%", zIndex: 10000, paddingTop: "50%", paddingBottom: "50%"}}>
                    {!this.props.selectedTag && <Icon value="success-no-circle" />}
                  </div>
                </div>,
                ...keys(publicTagNames).map(id => (
                  <div
                    key={id}
                    style={{
                      position: "relative",
                      flexGrow: 1,
                      flexShrink: 0,
                      minHeight: "6vh",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      border: `1px solid ${this.props.selectedTag == id ? "rgb(26, 173, 25)" : "#ccc"}`,
                      margin: "0.5vh 0 0.5vh 0",
                      backgroundColor: "white",
                      fontSize: "150%"
                    }}
                    onClick={() => this.props.onTag(id)}
                  >
                    <div
                      style={{
                        backgroundColor: typesColor[id] || "#D02800",
                        borderRadius: "50%",
                        margin: "-0.4vh 5px 0 5px",
                        flexBasis: "10%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}>
                      <Ionicon
                        icon={publicTagNames[id].icon}
                        fontSize="150%"
                        color="white"
                      />
                    </div>
                    {publicTagNames[id].name}
                    <div style={{position: "absolute", right: "5%", zIndex: 10000, paddingTop: "50%", paddingBottom: "50%"}}>
                      {this.props.selectedTag == id && <Icon value="success-no-circle" />}
                    </div>
                  </div>
                ))
              ]
            }
          </div>
        </div>
      </Dialog>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({ 
  selections: getSelections(state, ownProps), 
  userInfo: state.userInfo 
})

const mapDispatchToProps = dispatch => ({
  push: (url) => dispatch(push(url)),
})

export default connect(mapStateToProps, mapDispatchToProps)(UnconnectedModalTagSelector)



// WEBPACK FOOTER //
// ./src/app/catalogo/components/ModalTagSelector.jsx